import { MAX_DATE, MIN_DATE, MAX_ALLOW_DAYS } from './consts';
import { TEXTS } from './texts';

export const validateDateRange = (start: Date, end: Date): string | null => {
  if (start > end) {
    return TEXTS.WRONG_RANGE_START_MORE_END_ERROR;
  }

  const diffTime = end.getTime() - start.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays > MAX_ALLOW_DAYS) {
    return TEXTS.WRONG_RANGE_MORE_MAX_ERROR(MAX_ALLOW_DAYS);
  }

  if (start < MIN_DATE || end > MAX_DATE) {
    return TEXTS.WRONG_RANGE_LESS_MIN_OR_MORE_MAX_ERROR(MAX_ALLOW_DAYS);
  }

  return null;
};
